import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface DistrictDto {
  id: string;
  name: string;
  disabled?: string;
  deletedAt?: string;
  updatedAt?: string;
  createdAt?: string;
}

export interface CreateDistrictDto {
  id?: string;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class DistrictService {
  private readonly baseUrl = `${environment.apiConfig.uri}/api/District`;

  constructor(private http: HttpClient) {}

  getDistricts(): Observable<DistrictDto[]> {
    return this.http.get<DistrictDto[]>(`${this.baseUrl}/list`);
  }

  createDistrict(dto: CreateDistrictDto): Observable<{ id: string }> {
    return this.http.post<{ id: string }>(this.baseUrl, dto);
  }

  updateDistrict(dto: CreateDistrictDto): Observable<{ id: string }> {
    return this.http.patch<{ id: string }>(this.baseUrl, dto);
  }
}
